import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { Button } from '@progress/kendo-react-buttons';
import { GridColumnMenuProps } from '@progress/kendo-react-grid';
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs';
import { clone } from '@progress/kendo-react-common';
import React from 'react';

const ColumnCheckboxFilter = (props: GridColumnMenuProps & { data: { text: string; value: number }[] }) => {
    const getDefaultFilter = (): CompositeFilterDescriptor => {
        if (props.filter) {
            return clone(props.filter);
        }
        return { filters: [], logic: 'and' } as CompositeFilterDescriptor;
    };

    const getChecked = () => {
        const filter = props.filter?.filters
            ?.filter((x: any) => x.filters && x.filters.length > 0 && x.filters[0].field === props.column.field)
            .at(0);

        return (filter as CompositeFilterDescriptor)?.filters.map((x) => (x as FilterDescriptor).value as number) ?? [];
    };

    const [checked, setChecked] = React.useState<number[]>(getChecked());

    const handleFilter = (e: React.SyntheticEvent<any>) => {
        if (checked.length === 0 || checked.length === props.data.length) {
            handleClear(e);
            return;
        }

        if (!props.onFilterChange) {
            return;
        }

        const defaultFilter = getDefaultFilter();
        const targetFilter = defaultFilter.filters
            .filter((x: any) => x.filters && x.filters.length > 0 && x.filters[0].field === props.column.field)
            .at(0) as CompositeFilterDescriptor | undefined;

        if (targetFilter) {
            targetFilter.filters = checked.map((x) => ({
                field: props.column.field,
                value: x,
                operator: 'eq'
            }));
            targetFilter.logic = 'or';
        } else {
            if (checked.length > 0) {
                const newFilter: CompositeFilterDescriptor = {
                    logic: 'or',
                    filters: checked.map((x) => ({
                        field: props.column.field,
                        value: x,
                        operator: 'eq'
                    }))
                };
                defaultFilter.filters.push(newFilter);
            }
        }

        props.onFilterChange(defaultFilter, e);

        if (props.onCloseMenu) {
            props.onCloseMenu();
        }
    };

    const handleClear = (e: React.SyntheticEvent<any>) => {
        if (!props.onFilterChange) {
            return;
        }

        const defaultFilter = getDefaultFilter();
        defaultFilter.filters = defaultFilter.filters.filter(
            (x: any) => x.filters && x.filters.length > 0 && x.filters[0].field !== props.column.field
        );

        props.onFilterChange(defaultFilter, e);
        if (props.onCloseMenu) {
            props.onCloseMenu();
        }
    };

    const handleChange = (event: CheckboxChangeEvent, value: number) => {
        if (event.value) {
            setChecked((prev) => [...prev, value]);
        } else {
            setChecked((prev) => prev.filter((x) => x != value));
        }
    };

    const handleAllChange = () => {
        if (checked.length !== props.data.length) {
            setChecked(props.data.map((x) => x.value));
        } else {
            setChecked([]);
        }
    };

    return (
        <>
            <div>
                <div style={{ paddingLeft: '1.5rem', display: 'flex', flexDirection: 'column', gap: '0.33rem' }}>
                    <Checkbox checked={checked.length === props.data.length} label="Check all" onClick={handleAllChange} />
                    {props.data.map((x) => {
                        return (
                            <Checkbox
                                key={x.value}
                                label={x.text}
                                onChange={(e) => handleChange(e, x.value)}
                                checked={checked.includes(x.value)}
                            />
                        );
                    })}
                </div>
                <div style={{ paddingLeft: '.55em', paddingTop: '0.5rem' }} className="k-filter-selected-items">
                    {checked.length} selected items
                </div>
                <div className="k-actions k-hstack k-justify-content-stretchk-actions k-hstack k-justify-content-stretch">
                    <Button themeColor={'primary'} onClick={handleFilter}>
                        Filter
                    </Button>
                    <Button onClick={handleClear}>Clear</Button>
                </div>
            </div>
        </>
    );
};

export default ColumnCheckboxFilter;
